import { Table } from 'reactstrap';
import moment from 'moment';
import './TravelRequestOptions.scss';
import { HOTEL_COLUMNS } from './constants';

function HotelInformation({ isLoading, hotelDetails, showTitle = true }) {
  return (
    <div className="d-flex flex-column gap-2">
      {showTitle && <div className="fw-semibold">Hotel Information</div>}

      <div className="table-responsive">
        <Table
          hover
          className="tra-table align-middle text-nowrap table-radius"
          id="travel-option-table"
        >
          <thead>
            <tr>
              {HOTEL_COLUMNS.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {hotelDetails?.map((hotel, index) => (
              <tr key={index}>
                <td>{hotel.Country_Description || 'N/A'}</td>
                <td>{hotel.Place || 'N/A'}</td>
                <td>
                  {hotel.CheckInDate
                    ? moment(hotel.CheckInDate).format('L')
                    : 'N/A'}
                </td>
                <td>
                  {hotel.CheckOutDate
                    ? moment(hotel.CheckOutDate).format('L')
                    : 'N/A'}
                </td>
                <td>{hotel.HotelName || 'N/A'}</td>
              </tr>
            ))}
            {!isLoading && !hotelDetails?.length && (
              <tr>
                <td colSpan={HOTEL_COLUMNS.length} className="text-center">
                  No hotel details available
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default HotelInformation;
